import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useDashboard } from './useDashboard';
import { fetchJSON, AuthError } from '@/api/client';

export interface KPIData {
  mttr_ms: number;
  mttd_ms: number;
  total_incidents: number;
  resolution_rate: number;
  // API may return alternative field names
  mttr?: number;
  mttc?: number;
  incident_count?: number;
  recurrence_rate?: number;
  containment_failure_rate?: number;
}

export function useKPI() {
  const { token, logout } = useAuth();
  const { refreshKey } = useDashboard();
  const [kpis, setKpis] = useState<KPIData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    fetchJSON<KPIData>('/api/dashboard/kpi', token)
      .then((d) => {
        if (cancelled) return;
        // Normalize API response — map alternative field names
        const normalized: KPIData = {
          mttr_ms: d.mttr_ms ?? (d.mttr ? d.mttr * 1000 : 0),
          mttd_ms: d.mttd_ms ?? (d.mttc ? d.mttc * 1000 : 0),
          total_incidents: d.total_incidents ?? d.incident_count ?? 0,
          resolution_rate: d.resolution_rate ?? (1 - (d.containment_failure_rate ?? 0)),
        };
        setKpis(normalized);
        setLoading(false);
      })
      .catch((e) => {
        if (e instanceof AuthError) { logout(); return; }
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [token, refreshKey, logout]);

  return { kpis, loading };
}
